<template>
  <Loading v-if="loading" />
  <template v-else>
    <div class="flex justify-between items-center font-semibold">
      <p class="text-xl">{{ computedTitle }}</p>
      <p class="text-2xl" v-if="isPresent(breakdown?.general)">
        {{ this.formatPrice(totalCommission) }}
      </p>
    </div>
    <Selector
      v-if="isPresent(filters.sellerName)"
      id="seller_name"
      label="Vendeur"
      name="seller_name"
      v-model="selectedSellerName"
      :options="sellerOptions"
    />
    <BreakdownTable v-if="breakdown?.general" :breakdown="breakdown.general" />
    <div v-if="isPresent(breakdown?.salesByFormula)" class="grid grid-cols-1 gap-5 sm:grid-cols-2 mb-4">
      <div class="bg-white px-6 py-4 mt-5 rounded-lg shadow-lg">
        <PieChart title="Répartition de la rémunération par formule" :data="format(breakdown.salesByFormula)" />
      </div>
      <div class="bg-white px-6 py-4 mt-5 rounded-lg shadow-lg">
        <PieChart title="Répartition de la rémunération par durée" :data="format(breakdown.salesByTermLength)" />
      </div>
    </div>
  </template>
</template>

<script>
import BreakdownTable from "@/components/billing/invoice/breakdown/BreakdownTable.vue";
import InvoicesService from "@/api/services/invoices";
import Selector from "@/components/utils/Selector.vue";
import { PieChart, Loading, toCamelCase, formatPrice, isPresent } from "@estaly/ui";

export default {
  components: { BreakdownTable, Selector, PieChart, Loading },

  props: {
    invoice: {
      type: Object,
      required: true,
    },
    recurringBreakdown: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      filters: {
        salesChannel: [],
        sellerName: [],
      },
      breakdown: null,
      selectedSellerName: null,
      loading: true,
    };
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    params() {
      return {
        recurring_breakdown: this.recurringBreakdown,
        seller_name: this.selectedSellerName,
      };
    },

    computedTitle() {
      return this.recurringBreakdown ? "Rémunération récurrente" : "Rémunération générée par les nouvelles ventes";
    },

    sellerOptions() {
      const options = [{ value: null, label: "Tous les vendeurs" }];
      return options.concat(
        this.filters.sellerName.map((seller) => ({
          value: seller,
          label: seller,
        })),
      );
    },

    totalCommission() {
      return this.breakdown?.general?.reduce((sum, item) => sum + parseFloat(item.totalCommission || 0), 0) || 0;
    },
  },

  methods: {
    isPresent,
    formatPrice,
    async fetchData() {
      const response = await InvoicesService.fetchBreakdown(this.invoice.id, this.params);
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      this.filters = data.filters;
      this.breakdown = data.breakdown;
      this.loading = false;
    },
    format(input) {
      return input.reduce((acc, { values: { name, value } }) => {
        acc[name] = value;
        return acc;
      }, {});
    },
  },

  watch: {
    async selectedSellerName() {
      await this.fetchData();
    },
  },
};
</script>
